import Pepa from './Pepa';

export default () => {
  const lienzo = document.getElementById('fondo') as HTMLCanvasElement;
  const ctx = lienzo.getContext('2d') as CanvasRenderingContext2D;
  const dims = { ancho: 0, alto: 0, columnas: 0, filas: 0 };
  const cuadro = 20;
  const radio = 5;
  let cantidadPepas = 0;
  let ultimoCuadro = 0;
  const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let pepas: Pepa[] = [];

  escalar();
  if (reducirMovimiento) dibujar();
  else requestAnimationFrame(ciclo);

  function ciclo(ahora: number) {
    requestAnimationFrame(ciclo);

    // 30 FPS mantienen el movimiento fluido sin redibujar más de lo necesario.
    if (document.hidden || ahora - ultimoCuadro < 1000 / 30) return;
    ultimoCuadro = ahora;

    dibujar();
  }

  function dibujar() {
    ctx.clearRect(0, 0, dims.ancho, dims.alto);
    if (pepas.length !== cantidadPepas) return;
    ctx.beginPath();
    for (let fila = 0; fila < dims.filas; fila++) {
      for (let columna = 0; columna < dims.columnas; columna++) {
        const i = columna + fila * dims.columnas;
        pepas[i].actualizar(ctx);
      }
    }
    ctx.fill();
  }

  function escalar() {
    lienzo.width = dims.ancho = window.innerWidth;
    lienzo.height = dims.alto = window.innerHeight;
    dims.columnas = Math.ceil(dims.ancho / cuadro);
    dims.filas = Math.ceil(dims.alto / cuadro);
    ctx.fillStyle = 'rgba(245,245,60,0.5)';
    cantidadPepas = dims.columnas * dims.filas;
    pepas = [];

    for (let fila = 0; fila < dims.filas; fila++) {
      for (let columna = 0; columna < dims.columnas; columna++) {
        pepas.push(new Pepa(columna * cuadro, fila * cuadro, Math.random() * radio));
      }
    }

    if (reducirMovimiento) dibujar();
  }

  window.addEventListener('resize', escalar);
};
